export const AppUrls = {
    About: {
        CEMS: {
            routerPath: "copernicus-emergency-management-service-cems",
            url: `/copernicus-emergency-management-service-cems`
        },
        EFAS: {
            routerPath: "european-flood-awareness-system-efas",
            url: `/european-flood-awareness-system-efas`
        },
        FAQ: {
            routerPath: "faq",
            url: `/faq`
        }
    },
    Collaborate: {
        BecomeEFASPartner: {
            routerPath: "become-efas-partner",
            url: `/become-efas-partner`
        },
        EFASAndResearch: {
            routerPath: "efas-research",
            url: `/efas-research`
        },
        ShareYourData: {
            routerPath: "share-your-data-efas",
            url: `/share-your-data-efas`,
        },
        CEMSRapidMapping: {
            routerPath: "cems-rapid-mapping",
            url: `/cems-rapid-mapping`,
        },
        PartnersList: {
            routerPath: "partners-list",
            url: `/partners-list`,
        }
    },
    DataAccess: {
        ConditionsAccess: {
            routerPath: "efas-conditions-access",
            url: `/efas-conditions-access/`
        },
        MapViewer: {
            routerPath: "efas_frontend",
            url: `/map`
        },
        WebServices: {
            routerPath: "efas-web-services",
            url: `/efas-web-services`,
        },
        DataDownload: {
            routerPath: "data-download",
            url: `/data-download`
        }
    },
    Products: {
        Overview: {
            routerPath: "overview-of-available-products",
            url: `/overview-of-available-products`
        },
        MeteorologicalForecasts: {
            routerPath: "meteorological-forecasts",
            url: `/meteorological-forecasts`
        },
        FlashFloodIndicators: {
            routerPath: "flash-flood-indicators",
            url: `/flash-flood-indicators`
        },
        MediumRangeFloodForecasts: {
            routerPath: "medium-range-flood-forecasts",
            url: `/medium-range-flood-forecasts`
        },
        SeasonalOutlook: {
            routerPath: "seasonal-outlook",
            url: `/seasonal-outlook`
        },
        FloodImpactForecasts: {
            routerPath: "flood-impact-forecasts",
            url: `/flood-impact-forecasts`
        },
        ModelAndForecastSkill: {
            routerPath: "model-and-forecast-skill",
            url: `/model-and-forecast-skill`
        },
        EfasNotifications: {
            routerPath: "efas-notifications",
            url: `/efas-notifications`
        },
        Monitoring: {
            routerPath: "monitoring",
            url: `/monitoring`
        },
        PreTasking: {
            routerPath: "pre-tasking",
            url: `/pre-tasking`
        }
    },
    Feedbacks: {
        Root: "feedbacks",
        Formal: "formal",
        Informal: "informal",
        Flash: "flash",
        route: (notification_id: string, partner_abbr?: string) => {
            if (partner_abbr) {
                return `/feedbacks/${notification_id}/${partner_abbr}/`
            } else {
                return `/feedbacks/${notification_id}/`
            }
        }
    }

}